import $ from 'jquery';
// import shave from './shave';

export default () => {
  $('.view-id-certified_products_list .view-content')
    .addClass('owl-carousel owl-theme')
    .owlCarousel({
      margin: 37,
      rewind: false,
      autoWidth: true,
      loop: true,
      responsive: {
        '0': {
          items: 1,
          center: true,
        },
        '1024': {
          center: false
        },
        '1280': {
          autoWidth: false,
          items: 3,
          dotsEach: 3,
          loop: false,
        }
      }
    });
}
